import { render, staticRenderFns } from "./rmivdForm.vue?vue&type=template&id=7b59b1c3&scoped=true"
import script from "./rmivdForm.vue?vue&type=script&lang=js"
export * from "./rmivdForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b59b1c3",
  null
  
)

export default component.exports